import { useRef, useState } from "react";
import { RotateCcw, Maximize, Check, X, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

const FULL = [[0, 0], [1, 0], [1, 1], [0, 1]];
const clamp = (v) => Math.min(1, Math.max(0, v));

export default function AICornerEditor({ src, initial, busy, onApply, onCancel }) {
  const box = useRef(null);
  const drag = useRef(null);
  const [pts, setPts] = useState(initial);

  const move = (e) => {
    if (drag.current == null || !box.current) return;
    const r = box.current.getBoundingClientRect();
    const p = [clamp((e.clientX - r.left) / r.width), clamp((e.clientY - r.top) / r.height)];
    setPts((old) => old.map((q, i) => (i === drag.current ? p : q)));
  };
  const start = (i) => (e) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture?.(e.pointerId);
    drag.current = i;
  };

  return (
    <div className="space-y-2" data-testid="ai-corner-editor">
      <div className="text-[11.5px] text-slate-500">Seret 4 bucu merah jambu ke penjuru kertas, kemudian tekan <b>Potong</b>.</div>
      <div className="rounded-xl bg-slate-900 p-3 grid place-items-center">
        <div ref={box} className="relative select-none touch-none" onPointerMove={move} onPointerUp={() => { drag.current = null; }}>
          <img src={src} alt="asal" draggable={false} className="block max-h-[48vh] max-w-full rounded" />
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
            <polygon points={pts.map(([x, y]) => `${x * 100},${y * 100}`).join(" ")} fill="rgba(217,70,239,0.18)" stroke="#e879f9" strokeWidth="2" vectorEffect="non-scaling-stroke" />
          </svg>
          {pts.map(([x, y], i) => (
            <span key={i} onPointerDown={start(i)} style={{ left: `${x * 100}%`, top: `${y * 100}%` }} data-testid={`ai-corner-${i}`}
              className="absolute h-7 w-7 -ml-3.5 -mt-3.5 rounded-full border-[3px] border-white bg-fuchsia-500 shadow-lg cursor-grab active:cursor-grabbing touch-none active:scale-125 transition-transform" />
          ))}
        </div>
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        <Button variant="outline" className="rounded-xl text-[11px] px-1" onClick={() => setPts(initial)} disabled={busy} data-testid="ai-corner-reset"><RotateCcw className="h-3.5 w-3.5 mr-1" />Auto</Button>
        <Button variant="outline" className="rounded-xl text-[11px] px-1" onClick={() => setPts(FULL)} disabled={busy} data-testid="ai-corner-full"><Maximize className="h-3.5 w-3.5 mr-1" />Penuh</Button>
        <Button variant="outline" className="rounded-xl text-[11px] px-1" onClick={onCancel} disabled={busy} data-testid="ai-corner-cancel"><X className="h-3.5 w-3.5 mr-1" />Batal</Button>
        <Button className="rounded-xl text-[11px] px-1 bg-fuchsia-600 hover:bg-fuchsia-700 text-white" onClick={() => onApply(pts)} disabled={busy} data-testid="ai-corner-apply">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Check className="h-3.5 w-3.5 mr-1" />Potong</>}
        </Button>
      </div>
    </div>
  );
}
